import { AnyAction } from 'redux';
import { GetPositionListDto } from 'src/dtos';

import { createAction, State, Type } from './utils';

export const doGetPositionList = (payload: GetPositionListDto): AnyAction =>
  createAction(State.actionRequested(Type.GET_POSITION_LIST), payload);

export const doSucceededGetPositionList = (payload?: any): AnyAction =>
  createAction(State.actionSucceeded(Type.GET_POSITION_LIST), payload);

export const doFailedGetPositionList = (error: string): AnyAction =>
  createAction(State.actionFailed(Type.GET_POSITION_LIST), { error });

export const doClearGetPositionList = (): AnyAction => createAction(State.actionCleared(Type.GET_POSITION_LIST));
